export enum JsonInputType {
	Width = "width",
	WidthSection1 = "width_1",
	WidthSection2 = "width_2",
	Length = "length",
	LengthSection1 = "length_1",
	LengthSection2 = "length_2",
	LengthSection3 = "length_3",

	// Has no key at the moment in json
	StandardSizes = "standard_size",
	CompleteSizes = "complete_size",

	// Circles
	Diameter = "width",

	// Triangles
	Basis = "length",
	Height = "width",

	// With corners
	Depth = "depth",
	DepthA = "depth_a",
	DepthB = "depth_b",
	DepthC = "depth_c",
	DepthD = "depth_d",
	Radius = "radius",
	RadiusA = "radius_a",
	RadiusB = "radius_b",
	RadiusC = "radius_c",
	RadiusD = "radius_d",

	// Custom side count
	Points = "points",

	// 3D shapes
	Height3d = "height",

	// Tables shapes
	Thickness = "thickness",

	// Finishes
	FinishSelections = "finish_selections",
	FinishOptions = "finish_options",
	FinishOptionLength = "length",
	FinishOptionWidth = "width",
	FinishOptionDegrees = "degrees",
	FinishOptionRadius = "radius",
	FinishOptionDiameter = "diameter",
	FinishOptionDepth = "depth",
	FinishOptionHeight = "height",
	FinishOptionWholeLength = "complete_length",
	FinishOptionWholeWidth = "complete_width",
	FinishOptionDrillThrough = "drill_through",
	FinishOptionAbsBandColor = "absband",
	FinishOptionOffsetX = "offset_x",
	FinishOptionOffsetY = "offset_y",
	FinishOptionOffsetY1 = "offset_y1",
	FinishOptionOffsetY2 = "offset_y2",
	FinishOptionOffsetX1 = "offset_x1",
	FinishOptionOffsetX2 = "offset_x2",
	FinishOptionDrillSize = "drill_size",
	FinishOptionDeuvelSize = "deuvel_size",
	FinishOptionSide = "side",
	FinishItemCollection = "item_collection",

	Quantity = "quantity",

	CustomLabel = "label",

	Production = "production",

	Agreement = "accepted_condition",
}
